export const columns = function () {
  // 内保单号，机构名称，车牌号，内保起期，
  // 内保止期，被内保人，被内保人地止，车型，
  // 厂牌型号，发动机号，VIN码，车辆种类，
  // 核定人数，已使用年限，初登日期，出险次数，
  // 车损(内保额度），车损标准内保费，三者(内保额度），
  // 三者标准内保费，司机(内保额度），司机标准内保费，
  // 乘客(内保额度），乘客标准内保费，收费方式，标准内保费，
  // 整单折扣，应交内保费，客户折扣，客户内保费，费用政策，
  // 净费，实收，差额，审核人，审核时间，财务审核，财务审核时间，
  // 实际支付时间，制单人，审核人，业务员，创建时间，生效时间，创建时间，备注
  return [
	{
	    prop: "insBillId",
	    label: "流水号",
		minWidth: 200,
	},
    {
      prop: "bh",
      label: "内保单号",
      minWidth: 200,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 200,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "内保起期",
      minWidth: 100,
    },
    {
      prop: "endTime",
      label: "内保止期",
      minWidth: 100,
    },
    {
      prop: "personName",
      label: "被内保人",
      minWidth: 100,
    },
    {
      prop: "certNo",
      label: "身份证号",
      minWidth: 100,
    },
    {
      prop: "addr",
      label: "被内保人地址",
      minWidth: 100,
    },
    // {
    //   prop: "carType",
    //   label: "车型",
    //   minWidth: 100,
    // },
    {
      prop: "brandType",
      label: "厂牌型号",
      minWidth: 100,
    },
    {
      prop: "engineNo",
      label: "发动机号",
      minWidth: 100,
    },
    {
      prop: "vin",
      label: "VIN码",
      minWidth: 100,
    },
    {
      prop: "carType",
      label: "车辆种类",
      minWidth: 100,
    },
    {
      prop: "passengerCount",
      label: "核定人数",
      minWidth: 100,
    },
    {
      prop: "userYears",
      label: "已使用年限",
      minWidth: 100,
    },
    {
      prop: "carBeginDate",
      label: "初登日期",
      minWidth: 100,
    },
    {
      prop: "accidentCount",
      label: "出险次数",
      minWidth: 100,
    },
    {
      prop: "car_tcfee",
      label: "车损(内保额度)",
      minWidth: 100,
    },
    {
      prop: "car_bztcfee",
      label: "车损标准内保费",
      minWidth: 100,
    },
    {
      prop: "three_tcfee",
      label: "三者(内保额度)",
      minWidth: 100,
    },
    {
      prop: "three_bztcfee",
      label: "三者标准内保费",
      minWidth: 100,
    },
    {
      prop: "driver_tcfee",
      label: "司机(内保额度)",
      minWidth: 100,
    },
    {
      prop: "driver_bztcfee",
      label: "司机标准内保费",
      minWidth: 100,
    },
    {
      prop: "passenger_tcfee",
      label: "乘客(内保额度)",
      minWidth: 100,
    },
    {
      prop: "passenger_bztcfee",
      label: "乘客标准内保费",
      minWidth: 100,
    },
    {
      prop: "inType",
      label: "支付渠道",
      minWidth: 100,
    },
    {
      prop: "contractFee",
      label: "标准内保费",
      minWidth: 100,
    },
    {
      prop: "cusRebate",
      label: "整单折扣",
      minWidth: 100,
    },
    {
      prop: "cusFee",
      label: "应交内保费",
      minWidth: 100,
    },
    {
      prop: "customerRebate",
      label: "客户折扣",
      minWidth: 100,
    },
    {
      prop: "customerFee",
      label: "客户内保费",
      minWidth: 100,
    },
    {
      prop: "policy",
      label: "费用政策",
      minWidth: 100,
    },
	// {
	//   prop: "originalBill",
	//   label: "原始内保",
	//   minWidth: 100,
	// },
	{
	  prop: "originalRebate",
	  label: "原始折扣",
	  minWidth: 100,
	},
    {
      prop: "netFee",
      label: "净费",
      minWidth: 100,
    },
    {
      prop: "realInFee",
      label: "支付金额",
      minWidth: 100,
    },
    {
      prop: "diffe",
      label: "差额",
      minWidth: 100,
    },
    {
      prop: "auditName",
      label: "审核人",
      minWidth: 100,
    },
    {
      prop: "auditTime",
      label: "审核时间",
      minWidth: 100,
    },
    {
      prop: "",
      label: "财务审核",
      minWidth: 100,
    },
    {
      prop: "",
      label: "财务审核时间",
      minWidth: 100,
    },
    {
      prop: "payTime",
      label: "实际支付时间",
      minWidth: 100,
    },
    {
      prop: "creator_name",
      label: "制单人",
      minWidth: 100,
    },
    {
      prop: "sale_name",
      label: "业务员",
      minWidth: 100,
    },
    {
      prop: "create_time",
      label: "创建时间",
      minWidth: 100,
    },
    {
      prop: "",
      label: "生效时间",
      minWidth: 100,
    },
    {
      prop: "remark",
      label: "备注",
      minWidth: 100,
    },
	{
	  prop: "f_day",
	  label: "服务天数",
	  minWidth: 200,
	},
  ];
};

export default {};
